<template>
    <div>
        <div class="ah-panel setup-bank-step">
            <div class="panel-header gray init-step-header">
                <h1 class="title">設定銀行帳戶</h1>
                <div class="description">
                    <p>建立你的銀行帳戶，為收入和支出的帳戶。</p>
                </div>
            </div>
            <div class="panel-body">
                <el-table-draggable handle=".handle" :animate="300" @drop="onChangeSort">
                    <el-table :data="bankAccountList" empty-text="沒有帳戶" v-loading="isLoading">
                        <el-table-column width="45px">
                            <template slot-scope="">
                                <div class="handle">
                                    <div v-for="i in 3" :key="i" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column type="index" label="#"></el-table-column>
                        <el-table-column prop="tpc" label="帳戶簡稱">
                            <template slot-scope="scope">
                                <div>{{ scope.row.tpc }} <span v-if="scope.row.isBorrower" class="borrow-label">借款戶</span></div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="bnK_BOO" label="銀行 / 帳號">
                            <template slot-scope="scope">
                                <div v-if="scope.row.bnK_BOO === '000' && scope.row.bnK_DOO === '000000'">暫存戶</div>
                                <div v-else>
                                    <div style="white-space: nowrap">{{ getBankName(scope.row.bnK_BOO) }}</div>
                                    <div>{{ scope.row.bnK_ACC }}</div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="bnK_NAM" label="存摺戶名"></el-table-column>
                        <el-table-column prop="amt" label="餘額" align="right" width="110">
                            <template slot-scope="scope">
                                <Money :v="scope.row.amt" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="cnynam" label="幣別" align="center" width="80"></el-table-column>
                        <el-table-column prop="" label="操作" width="90">
                            <template slot-scope="scope">
                                <el-button size="small" class="" @click="handleDeleteBtnClick(scope.row.sno)" v-if="scope.row.isUsed == false">刪除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-table-draggable>
                <div
                    style="
                        text-align: center;
                        margin-top: 30px;
                        margin-bottom: 30px;
                    "
                >
                    <el-button plain round type="primary" id="init-page-add-bank-btn" class="primary-action" @click="handleAddBtnClick">新增帳戶</el-button>
                </div>
                <center class="actions">
                    <el-button type="" class="primary-action prev-btn" @click="handlePrev">回上一步</el-button>
                    <el-button type="primary" class="primary-action next-btn" @click="handleNext">下一步</el-button>
                </center>
            </div>
        </div>
        <el-dialog :visible.sync="editDialogVisible" width="" :before-close="handleEditDialogClose" :close-on-click-modal="false" class="ah-detail-dialog" id="init-page-add-bank-dialog">
            <template slot="title"> 新增銀行帳戶 </template>
            <div class="detail-row" style="padding-top: 30px">
                <BankAccountForm v-if="editDialogVisible" ref="form" :lite="true" />
            </div>
            <div class="detail-row footer" style="text-align: center">
                <div style="margin: 0 0 5px 0">
                    銀行帳號、存摺戶名……等欄位儲存後不可修改，請再次確認資訊是否正確。
                </div>
                <div style="margin: 0 0 25px 0">
                    <el-checkbox v-model="isAllChecked" name="checked">
                        我已確認資訊皆正確
                    </el-checkbox>
                </div>
                <el-button id="init-page-add-bank-submit-btn" type="primary" class="primary-action" :loading="isAdding" :disabled="!isAllChecked" @click="onCreateBank">
                    送出
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import _ from 'lodash';
import BankAccountForm from '@/components/dashboard/Finance/BankAccount/BankAccountForm.vue';
import ElTableDraggable from 'element-ui-el-table-draggable';

export default {
    components: {
        BankAccountForm,
        ElTableDraggable,
    },
    data() {
        return {
            bankAccountList: [],
            originalData: [],
            bankList: [],

            editDialogVisible: false,
            isLoading: false,
            isAdding: false,
            isAllChecked: false,
        };
    },
    mounted() {
        this.fetchBankList(() => {
            this.updateBankAccountList();
        });
    },
    methods: {
        // 更新銀行帳戶列表
        async updateBankAccountList() {
            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url: '/BankAccountSettingPage/GetSettings?PageSize=999&PageNum=1',
                    method: 'GET',
                });

                this.bankAccountList = resp.data.settings;
                this.originalData = [...this.bankAccountList];
            } finally {
                this.isLoading = false;
            }
        },

        // 取得人員明細
        fetchBankAccountData(sno) {
            this.$api({
                url: `/BankAccountSettingPage/GetSettingDetail?SNO=${sno}`,
                method: 'GET',
            }).then((resp) => {
                this.form = resp.data.setting;
                console.log(resp.data.setting);
            });
        },

        // 取得銀行列表
        fetchBankList(callback) {
            this.$api({
                url: '/Tool/GetBankOptions',
                method: 'GET',
            }).then((resp) => {
                this.bankList = resp.data.options;
                callback();
            });
        },

        getBankName(boo) {
            const bank = this.bankList.find((item) => item.boo == boo);
            if (bank) return `(${boo}) ${bank.nam}`;
            return boo;
        },

        // 編輯按鈕
        handleEdit(data) {
            this.fetchBankAccountData(data.sno);
            this.editDialogVisible = true;
        },

        // 新增按鈕
        handleAddBtnClick() {
            this.editDialogVisible = true;
        },

        // 編輯視窗關閉事件
        handleEditDialogClose() {
            this.editDialogVisible = false;
            this.updateBankAccountList();
        },

        // 儲存
        async onCreateBank() {
            await this.$refs.form.onSubmit(() => {
                this.editDialogVisible = false;
                this.$message({
                    showClose: true,
                    message: '成功新增帳戶',
                    type: 'success',
                });
                this.updateBankAccountList();
                this.isAllChecked = false;
            });
        },

        // scrollViewToError() {
        //     setTimeout(() => {
        //         const isError = document.getElementsByClassName('is-error');
        //         if (isError.length > 0) {
        //             isError[0].scrollIntoView({
        //                 block: 'center',
        //                 behavior: 'smooth',
        //             });
        //         }
        //     }, 100);
        // },

        handleDeleteBtnClick(sno) {
            this.$confirm('確定要刪除帳戶？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.submitDelete(sno);
            });
        },

        submitDelete(sno) {
            this.$api({
                url: '/BankAccountSettingPage/DeleteSetting',
                method: 'post',
                data: { id: sno },
            }).then(() => {
                this.updateBankAccountList();
            });
        },

        // 上一步
        handlePrev() {
            this.$router.push({ name: 'setup-start' });
        },

        // 下一步
        handleNext() {
            this.$router.push({ name: 'setup-statement' });
        },

        async onChangeSort() {
            const sorted = _.map(this.bankAccountList, (o, i) => ({
                sno: o.sno,
                sot: i,
            }));
            this.isLoading = true;
            try {
                await this.$api({
                    url: 'BankAccountSettingPage/UpdateSort',
                    method: 'POST',
                    data: { items: sorted },
                });
            } catch (e) {
                this.bankAccountList = [...this.originalData];
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
<style lang="scss">
.setup-bank-step {
    .handle {
        position: relative;
        width: 18px;
        height: 30px;
        margin: auto;
        > * {
            position: absolute;
            width: 100%;
            height: 2px;
            background-color: #ddd;
            transform: translateY(-50%);
        }
        :nth-child(1) {
            top: calc(50% + 5px);
        }
        :nth-child(2) {
            top: 50%;
        }
        :nth-child(3) {
            top: calc(50% - 5px);
        }
    }

    .borrow-label {
        background-color: #f95a7e;
        color: #fff;
        padding: 2px 5px;
        font-weight: bold;
        font-size: 9pt;
        border-radius: 5px;
        margin-right: 7px;
    }
}
</style>
